import React from 'react';
import {useTranslation} from 'react-i18next';

import {theme}      from '../constants';
import {components} from '../components';

export const Expired: React.FC = () => {
  const {t} = useTranslation();

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: theme.colors.ghostWhite,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '40px clamp(20px, 6vw, 32px)',
      textAlign: 'center',
    }}>
      <components.LanguageSwitcher
        containerStyle={{position: 'fixed', top: 16, insetInlineEnd: 16, zIndex: 10}}
      />

      <img src='/logo.webp' alt='Logo' style={{height: 30, marginBottom: 48, opacity: 0.7}} />

      <div style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '4px 12px',
        borderRadius: 6,
        border: '1px solid rgba(201,132,90,0.25)',
        backgroundColor: 'rgba(201,132,90,0.06)',
        marginBottom: 20,
      }}>
        <div style={{width: 7, height: 7, borderRadius: '50%', backgroundColor: theme.colors.mainColor}} />
        <span style={{
          fontSize: 11,
          fontWeight: 600,
          color: theme.colors.mainColor,
          fontFamily: "'SS3', sans-serif",
          letterSpacing: '0.06em',
          textTransform: 'uppercase',
        }}>
          {t('expired.title')}
        </span>
      </div>

      <div style={{
        fontSize: 14,
        color: theme.colors.bodyTextColor,
        fontFamily: "'SS3', sans-serif",
        lineHeight: 1.7,
        maxWidth: 300,
      }}>
        {t('expired.line1')}
      </div>
      <div style={{
        marginTop: 6,
        fontSize: 14,
        color: theme.colors.bodyTextColor,
        fontFamily: "'SS3', sans-serif",
        lineHeight: 1.7,
        maxWidth: 300,
      }}>
        {t('expired.line2')}
      </div>
    </div>
  );
};
